jQuery(document).ready(function() {
    // Set "refresh" link handler
    jQuery('.spbc_widget_refresh_link').on('click', function() {
        jQuery('.spbc_preloader').show();
        setTimeout(function() {
            window.scrollTo(0, jQuery('#spbc_widget_wrapper').offset().top - 130);
        }, 1);
        setTimeout(function() {
            jQuery('#spbc_refresh_form').submit();
        }, 2500);
    });

    if (location.hash == '#ct_widget') {
        setTimeout(function() {
            window.scrollTo(0, jQuery('#spbc_widget_wrapper').offset().top - 130);
        }, 1);
    }

    // Fixing default wrapper style
    jQuery('#spbc_widget_wrapper').parent().css('padding', 0);

    locale = navigator.language || navigator.userLanguage;

    let dateFormatter = new Intl.DateTimeFormat(locale, {
        month: 'short',
        day: 'numeric',
    });

    /**
     * Reformat Widget Data
     * @param {array} spbcDashboardWidget
     * @return {array}
     */
    function reformatWidgetData(spbcDashboardWidget) {
        let widgetData = {'labels': [], 'counts': []};
        for (let i = 0; i < spbcDashboardWidget.length; i++) {
            widgetData.labels.push(dateFormatter.format(new Date(spbcDashboardWidget[i]['0'])));
            widgetData.counts.push(spbcDashboardWidget[i]['1']);
        }
        return widgetData;
    }

    const ctx = document.getElementById('spbc_widget_chart');
    // let widgetData = reformatWidgetData(spbcDashboardWidget['data'])
    let widgetDataFW = reformatWidgetData(spbcDashboardWidget['data_fw']);
    let widgetDataBFP = reformatWidgetData(spbcDashboardWidget['data_bfp']);

    new Chart(ctx, {
        type: 'bar',
        data: {
            labels: widgetDataFW.labels,
            datasets: [
                {
                    label: 'Visitors blocked by Bruteforce Protection',
                    data: widgetDataBFP.counts,
                    borderWidth: 1,
                    backgroundColor: 'gray',
                },
                {
                    label: 'Visitors blocked by Firewall',
                    data: widgetDataFW.counts,
                    borderWidth: 1,
                    backgroundColor: 'steelblue',
                },
            ],
        },
        options: {
            legend: {
                display: false,
            },
            maintainAspectRatio: false,
            responsive: true,
            scales: {
                y: {
                    ticks: {
                        precision: 0,
                    },
                },
            },
            title: {
                display: true,
                text: 'Blocked attacks',
                fontSize: 18,
            },
            plugins: {
                legend: {
                    display: false,
                },
                title: {
                    display: true,
                    text: 'Blocked attacks',
                    font: {
                        size: 18,
                    },
                },
            },
            elements: {
                bar: {
                    backgroundColor: 'steelblue',
                },
            },
            animations: {
                tension: {
                    duration: 1000,
                    easing: 'linear',
                    from: 1,
                    to: 0,
                    loop: true,
                },
            },

        },
    });
});
